import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { WebPageShell } from '../components/common/WebPageShell';
import { CanteenContent } from '../components/canteen/CanteenContent';
import { useTheme } from '../context/ThemeContext';

/** The school canteen - web layout with the sidebar shell. */
export function CanteenScreen() {
  const { colors } = useTheme();

  return (
    <WebPageShell title="Canteen" maxWidth={1280}>
      <View style={styles.header}>
        <Text style={[styles.title, { color: colors.textPrimary }]}>Canteen</Text>
        <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
          Order meals for the child chosen at the top - one day or the whole week - paid from their wallet.
        </Text>
      </View>
      <CanteenContent />
    </WebPageShell>
  );
}

const styles = StyleSheet.create({
  header: { marginBottom: 16 },
  title: { fontSize: 22, fontWeight: '800' },
  subtitle: { fontSize: 13, marginTop: 4 },
});
